var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "02a74fe1f186449934c7080308376a0c8e43c72c"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["ecommerce-rms-rodi-ca@rodi"] = {
  id: "02a74fe1f186449934c7080308376a0c8e43c72c"
};